import './App.css';
import { BrowserRouter } from 'react-router-dom';
import AppContent from "./AppContent"
import ScrollToTop from './lib/utils/ScrollTop';
import { Toaster } from 'react-hot-toast';
import { TimerProvider } from './lib/utils/TimerContext';
import NotificationHandler from './lib/utils/NotificationHandler';

function App() {
  return (
    <div className="font-cairo overflow-hidden"  >
        <BrowserRouter>
          <NotificationHandler />
          <Toaster/>
          <ScrollToTop/>
          <TimerProvider>
            <AppContent />
          </TimerProvider>
        </BrowserRouter>
    </div>
  );
}

export default App;
